/* Veithdia v1.6 · pulido (15-10-2026)
   - Carrito: oculta la opción "Presentación" (tiene un solo valor) y la coma que sobra.
   - Accesibilidad: nombre para el campo de cantidad y rol correcto en los puntos de los sliders. */
(function () {
  var ONLY_ONE_VALUE = /^\s*Presentaci[oó]n\s*:?\s*$/i;

  function cleanCart(root) {
    root.querySelectorAll('.cart-item__details .product-option, .cart-notification-product .product-option').forEach(function (el) {
      var dt = el.querySelector('dt');
      var dd = el.querySelector('dd');
      if (!dt || !dd) return;
      if (ONLY_ONE_VALUE.test(dt.textContent)) {
        if (el.style.display !== 'none') el.style.display = 'none';
        return;
      }
      var text = dd.textContent;
      var clean = text.replace(/\s*,\s*$/, '').trim();
      if (clean !== text.trim()) dd.textContent = clean;
    });
  }

  function fixA11y(root) {
    root.querySelectorAll('.vt-dots[role="tablist"]').forEach(function (el) {
      el.removeAttribute('role');
    });
    root.querySelectorAll('input.quantity__input:not([aria-label])').forEach(function (el) {
      el.setAttribute('aria-label', 'Cantidad');
    });
  }

  function run() {
    cleanCart(document);
    fixA11y(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
